export function isDateInRange(
    start: Date,
    end: Date,
    currentDate: Date
): boolean {
    if (start && end && currentDate) {
        return (
            start.getTime() <= currentDate.getTime() &&
            end.getTime() >= currentDate.getTime()
        );
    } else {
        return false;
    }
}

export function isDateBefore(
    currentDate: Date,
    beforeDate: Date
): boolean {
    if (currentDate && beforeDate) {
        return (
            currentDate.getTime() <= beforeDate.getTime()
        );
    } else {
        return false;
    }
}

export function isDateBeforeMinutes(
    checkDate: Date,
    durationInMinutes: number
): boolean {
    return (
        checkDate.getTime() <= new Date().getTime() - durationInMinutes * 60000
    );
}
